type IMethod = 'GET' | 'POST' | 'get' | 'post';

export interface IHttpParams {
  baseUrl?: string;
  url: string;
  method?: IMethod;
  body?: any;
  query?: any;
  headers?: any;
  credentials?: 'include' | 'omit' | 'same-origin';
}

export interface IHttpStatus {
  errMsg: string;
  errNo: number;
}

export interface IHttpReturnData extends IHttpStatus {
  _data: any;
  status: number;
}

export class HttpError extends Error {
  errNo: number;
  errMsg: string;
  constructor(message: string, errNo: number) {
    super(message);
    this.errNo = errNo;
    this.errMsg = message;
    Object.setPrototypeOf(this, HttpError.prototype);
  }
}
export const ErrNo = {
  // 网络原因导致的错误码定义为负数，和server端的错误码区分开
  NetWorkError: -1,
};
